import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  cartItems: localStorage.getItem("cartItems")
    ? JSON.parse(localStorage.getItem("cartItems"))
    : [],
  coupon: localStorage.getItem("coupon")
    ? JSON.parse(localStorage.getItem("coupon"))
  : null,
};

const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    addToCart: (state, action) => {
      const { product, quantity = 1 } = action.payload;
      const existingItem = state.cartItems.find(
        (item) => item.product.id === product.id
      );

      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        state.cartItems.push({ product, quantity });
      }

      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter(
        (item) => item.product.id !== action.payload
      );
      localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
    },

    updateQuantity: (state, action) => {
      const { product_id, quantity } = action.payload;
      const item = state.cartItems.find((item) => item.product.id === product_id);

      if (item && quantity > 0) {
        item.quantity = quantity;
        localStorage.setItem("cartItems", JSON.stringify(state.cartItems));
      }
    },

    clearCart: (state) => {
      state.cartItems = [];
      state.coupon = null; 
      localStorage.removeItem("cartItems");
      localStorage.removeItem("coupon");
    },
    applyCoupon: (state, action) => {
      state.coupon = action.payload; // payload = { code, discount_amount, type }
      localStorage.setItem("coupon", JSON.stringify(state.coupon));
    },
    removeCoupon: (state) => {
      state.coupon = null;
      localStorage.removeItem("coupon");
    },
  },
});

export const { addToCart, removeFromCart, updateQuantity, clearCart, applyCoupon, removeCoupon} =
  cartSlice.actions;
export default cartSlice.reducer;
